// Enhance the native interior-page disclosure without changing its no-JS behavior.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest?.('details.rw-mobile-menu');
  if (!menu?.open) return;
  event.preventDefault();
  event.stopPropagation();
  menu.open = false;
  menu.querySelector('summary')?.focus();
});
